import {
  combineReducers
} from 'redux'
import {
  createReducer
} from 'helpers/ReducerUtil'
import {
  UPDATE_INPUT_VALUE,
  CLEAR_PROJECT_LIST,
} from './constants'

const updateInputValue = (state, action) => action.value
const clearInputValue = () => ''

const inputValueReducer = createReducer('', {
  [UPDATE_INPUT_VALUE]: updateInputValue,
  [CLEAR_PROJECT_LIST]: clearInputValue
})

export const uiStateReducer = combineReducers({
  inputValue: inputValueReducer,
})
